/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Microsoft_Tenant_TitleInputs */



/**
* | output |
* | --- |
* | "Microsoft sign-in" |
*
* @param {Microsoft_Tenant_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const microsoft_tenant_title = /** @type {((inputs?: Microsoft_Tenant_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Microsoft_Tenant_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Microsoft-Anmeldung")
	return /** @type {LocalizedString} */ ("Microsoft sign-in")
});